module.exports = __webpack_public_path__ + "static/media/scanpay-logo-black.b33cd2da.svg";